import { enqueueSnackbar } from "notistack";
import { PPTReport, ServerAPIResponse } from "../helpers/interfaces";
import { callServerAPI, showBackDrop } from "../helpers/utils";

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'


const MySwal = withReactContent(Swal);


export const getAllPPTReports = async () => {
    return await new Promise<PPTReport[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading Generated Reports"));
        callServerAPI<ServerAPIResponse<PPTReport[]>>('GET', `/api/v1/PPTReports/GetAllGeneratedPPTReports?&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                resolve(response.data.data)
            })
    })
}

export const getGeneratedPPTReports = async (id: string) => {
    return await new Promise<PPTReport>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading Generated Report"));
        callServerAPI<ServerAPIResponse<PPTReport>>('GET', `/api/v1/PPTReports/GetGeneratedPPTReports?pptReportsId=${id}`, null, true)
            .then(response => {
                MySwal.close()
                resolve(response.data.data)
            })
    })
}

export const GeneratePPTReports = async (pptReportsRequest: any) => {
    MySwal.fire(showBackDrop("Generating PPT Reports"));
    return await new Promise<any>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Creating PPT Rules Categorisation"));
        callServerAPI<ServerAPIResponse<any>>('POST', `/api/v1/PPTReports/GeneratePPTReports?api-version=1`, pptReportsRequest, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("PPT Rules Categorisation Created", { variant: 'success' });
                resolve(response.data.data)
            })
           
    })
    
}

export const exportPPTReport = async (id: string) => {
    return await new Promise<string>(async (resolve, reject) => {
        MySwal.fire(showBackDrop(" Exporting PPT Report "));
        callServerAPI<ServerAPIResponse<string>>('GET',  `/api/v1/PPTReports/ExportPPTReports?pptReportsId=${id}&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar(" PPT Report  Exported", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}